/**
 * Created by - Ashlekh on 04-02-2025
 * Reason - To add Event page
 */

import { useContext, useEffect, useState } from "react";
import style from "./event.module.css";
import { GlobalContext } from "../../context/Context";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import parse from "html-react-parser";
import { getEventDetailsAPI } from "../../Api/services";
import "react-multi-carousel/lib/styles.css";
import config from "../../Api/config";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { Link } from "react-router-dom";

const Event = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [eventData, setEventData] = useState([]);
  // Added by - Ashlekh on 04-02-2025
  // Reason - This useEffect will executes when page loads and will set navigation path
  useEffect(() => {
    window.scrollTo(0, 0);
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "Event", path: "/event" },
    ]);
    eventDetails();
  }, []);
  // End of code - Ashlekh on 04-02-2025
  // Reason - This useEffect will executes when page loads and will set navigation path

  // Added by - Ashlekh on 04-02-2025
  // Reason - To get details of event page
  const eventDetails = async () => {
    try {
      const response = await getEventDetailsAPI();
      setEventData(response?.event);
    } catch (error) {
      console.error("Error fetching Event details: ", error);
    }
  };
  // End of code - Ashlekh on 04-02-2025
  // Reason - To get details of event page
  
  return (
    <div className={`${style.mainContainer}`}>
      <NavigationPath navigationPathArray={navigationPath} />
      {eventData?.length > 0 ? (
        <div className={style.pageTitle}>
          <div className={style.title}>
            <span className={style.firstThree}>Eve </span>
            <span className={style.gradientText}>nts</span>
          </div>
        </div>
      ) : (
        <p className={style.noDetailsAvailableText}>No details available</p>
      )}
      {eventData?.length > 0 && (
        <div className={`${style.subContainer}`}>
          {eventData?.map((item, index) => {
            // Added by - Ashlekh on 04-02-2025
            // Reason - In Event table there are 5 image fields, to set all the images in a variable (as these variable will be used in swiper)
            const allImages = [];
            if (item.image1) allImages.push(item.image1);
            if (item.image2) allImages.push(item.image2);
            if (item.image3) allImages.push(item.image3);
            if (item.image4) allImages.push(item.image4);
            if (item.image5) allImages.push(item.image5);
            // End of code - Ashlekh on 04-02-2025
            // Reason - In Event table there are 5 image fields, to set all the images in a variable (as these variable will be used in swiper
            return (
              <div
                key={index}
                className={`${style.imageAndDescriptionContainer}`}
              >
                {/* <Carousel responsive={eventImages} arrows={true}>
                  {allImages?.map((image, imgIndex) => (
                    <div key={imgIndex} className={`${style.imageContainer}`}>
                      <img
                        src={config.baseURL + image}
                        className={`${style.image}`}
                        alt=""
                      />
                    </div>
                  ))}
                </Carousel> */}
                <Swiper
                  modules={[Navigation]}
                  navigation
                  spaceBetween={10}
                  slidesPerView={1}
                  className={style.imageContainer}
                >
                  {allImages?.map((image, imgIndex) => (
                    <SwiperSlide key={imgIndex}>
                      <img
                        src={config.baseURL + image}
                        className={`${style.image}`}
                        alt=""
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
                <div className={`${style.descriptionContainer}`}>
                  <div className={`${style.description}`}>
                    {/* {parse(item.description)} */}
                    {parse(
                      item?.description?.length > 250
                        ? item?.description.substring(0, 250) + "..."
                        : item?.description
                    )}
                  </div>
                  <div className={`${style.readMoreButton}`}>
                    <Link
                      to={"/event_detailed"}
                      state={item.id}
                      className={`${style.navigationLink}`}
                    >
                      Read more
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Event;
